import './index.css';
import ReactDOM from 'react-dom/client';
import App from './custom/App';

ReactDOM.createRoot(document.getElementById('root')).render(
    <App />
);

